// Vendor
import { createReducer, on } from '@ngrx/store';
// Actions
import { deleteSystemAlert, createSystemAlert } from './system-alert-items.actions';
import { setAlertFetchSuccess } from 'AlertsApp/ts/features/alerts-modals/state/alert-modal-status/alert-modal-status.actions';
// Constants
import { METRIC_ALERT_LIMIT } from 'AlertsApp/ts/features/alerts-modals/constants';
export const systemAlertItems = createReducer([], on(setAlertFetchSuccess, (state, action) => {
    return action.alerts.filter((alert) => alert.alert_type !== METRIC_ALERT_LIMIT);
}), on(createSystemAlert, (state, action) => {
    return [...state, action.alert];
}), on(deleteSystemAlert, (state, action) => {
    return state.filter((alert) => {
        // alerts are unique based on id, alert type, and object type
        return !(alert.id === action.alert.id &&
            alert.alert_type === action.alert.alert_type &&
            alert.object_type === action.alert.object_type);
    });
}));
